import AppView from '@common/components/app-view';
import ChatView from './chat-view';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

export default function BtTeamInboxView() {
    const { t } = useTranslation(namespace);

    return (
        <AppView title={t('logs.teamInbox')} activeExtensionView="team-inbox" showHeader={false}>
            <ChatView />
        </AppView>
    );
}
